import { isPaymentRoute } from '~/utils/optimizely/payment-routes'

/**
 * Global middleware — PCI DSS compliance.
 *
 * Removes Optimizely (script tag + window global) when SPA-navigating
 * to the payment step of the Health Online Application.
 * The app.vue route watcher re-initialises Optimizely automatically
 * when the user navigates away from payment pages.
 */

export default defineNuxtRouteMiddleware(to => {
  if (import.meta.server) return

  if (!isPaymentRoute(to.path)) return

  const { $optimizelyClient } = useNuxtApp()
  if ($optimizelyClient) {
    $optimizelyClient.destroy()
  }
})
